import React from 'react';
import { pxToRem } from '../util';
import { ConfigProvider, Pie } from '@ant-design/charts';
import CardHeader from './CardHeader';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const config = {
    scale: {
      color: {
        type: 'ordinal',
        range: ['#ff7875', '#ffc069', '#95de64', '#8c8c8c'],
      },
    },
    data: [
      {
        label: '重点关爱人群',
        value: props.charts?.populationDistribution?.keyPopulationTotal || 0,
      },
      {
        label: '一般健康人群',
        value:
          props.charts?.populationDistribution?.generalPopulationTotal || 0,
      },
      {
        label: '基本健康人群',
        value: props.charts?.populationDistribution?.basicPopulationTotal || 0,
      },
      {
        label: '待评估人群',
        value:
          props.charts?.populationDistribution?.toBeEvaluatedPopulationTotal ||
          0,
      },
    ],
    angleField: 'value',
    colorField: 'label',
    label: {
      text: 'value',
      position: 'outside',
    },
    legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
  };
  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: '35vh',
        maxHeight: '35vh',
        overflow: 'hidden',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      {/* <div
        style={{
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          fontSize: pxToRem(18),
        }}
      >
        <span>人群风险等级情况</span>
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          Risk level status
        </span>
      </div> */}
      <CardHeader title="人群风险等级情况" subtitle="Risk level status" />

      <div>
        <div style={{ height: '27vh' }}>
          <ConfigProvider
            common={{
              theme: {
                type: 'dark', // 基于 dark 主题定制
                axis: {
                  labelFill: color,
                },
              },
            }}
          >
            <Pie {...config} />
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};
export default Box1;
